import factoryApi from '@/api/factoryApi'

const SET_FACTORY_LIST = 'setFactoryList'
const SET_FACTORY_COUNT = 'setFactoryCount'

const SET_ADV_REGISTRY_LIST = 'setAdvRegistryList'
const SET_ADV_REGISTRY_COUNT = 'setAdvRegistryCount'

const SET_ADV_REGISTRY_FILTER_FLAG = 'setAdvRegistryFilterFlag'

const state = {
  advRegistryList: [],
  advRegistryCount: 0,

  factoryList: [],
  factoryCount: 0,

  advReistryFilterFlag: false
}

const mutations = {
  [SET_ADV_REGISTRY_LIST] (state, advRegistryList) {
    state.advRegistryList = advRegistryList
  },
  [SET_ADV_REGISTRY_COUNT] (state, count) {
    state.advRegistryCount = count
  },

  [SET_FACTORY_LIST] (state, factoryList) {
    state.factoryList = factoryList
  },
  [SET_FACTORY_COUNT] (state, count) {
    state.factoryCount = count
  },

  [SET_ADV_REGISTRY_FILTER_FLAG] (state, flag) {
    state.advRegistryFilterFlag = flag
  }
}

const actions = {
  async getFactories ({ commit }, data) {
    try {
      const res = await factoryApi.getFactories(data.page, data.pageSize, data.sort, data.filters)

      if (res && res.rcode === 0) {
        commit(SET_FACTORY_LIST, res.data.factories)
        commit(SET_FACTORY_COUNT, res.data.count)
      }
      return res
    } catch (err) {
      return err
    }
  },

  async getAdvRegistries ({ commit }, data) {
    try {
      const res = await factoryApi.getAdvRegistries(data.page, data.pageSize, data.sort, data.filters)

      if (res && res.rcode === 0) {
        commit(SET_ADV_REGISTRY_LIST, res.data.adv_registries)
        commit(SET_ADV_REGISTRY_COUNT, res.data.count)
      }
      return res
    } catch (err) {
      return err
    }
  },
  async batchAddAdvRegistries ({ commit }, data) {
    try {
      return await factoryApi.batchAddAdvRegistries(data.count, data.type, data.goodsLength)
    } catch (err) {
      return err
    }
  },
  async batchBindAdvRegistries ({ commit }, data) {
    try {
      return await factoryApi.batchBindAdvRegistries(data.userid, data.sns, data.clientids, data.factoryId,
        data.title, data.platform, data.protocol, data.connEncry)
    } catch (err) {
      return err
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

export {
  SET_ADV_REGISTRY_FILTER_FLAG
}



// WEBPACK FOOTER //
// ./src/store/modules/factory.js